// @flow

import { type IncomingPayment, getHash } from '@tectonics/prs/incoming-payment';
import { sendGA4Event, buildCommonEventParams } from './send-ga4-event';

export const GA4_VOUCHER_DEDUP_PREFIX = 'ga4_voucher_';

export function sendGA4VoucherGeneratedOnce(
  payment: IncomingPayment,
  overrides?: {| payment_method?: string |},
) {
  try {
    const paymentHash = getHash(payment);
    const dedupKey = GA4_VOUCHER_DEDUP_PREFIX + paymentHash;
    if (!sessionStorage.getItem(dedupKey)) {
      const commonParams = buildCommonEventParams(payment);
      const eventParams = { ...commonParams };
      if (overrides != null && overrides.payment_method) {
        eventParams.payment_method = overrides.payment_method;
      }
      sendGA4Event('voucher_generated', eventParams);
      sessionStorage.setItem(dedupKey, 'true');
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('GA4 voucher_generated dedup error:', e);
  }
}
